export default {
  users: {
    list_of_users: 'ユーザー一覧',
    role: '役割',
    number_of_authorized_exhibitors: '許可された出展者数',
    firstname: '名',
    lastname: '姓',
    email: 'メールアドレス',
    create_a_new_moderator: '新しいモデレーターを作成',
    exhibitors: '出展者',
    collective: '共同出展',
    events: 'イベント',
    password: 'パスワード',
    phone: '電話番号',
    last_login: '最終ログイン',
    confirm_remove_user: 'ユーザーの削除を確認しますか？',
    company: '会社',
    add_company: '会社を追加',
    confirm_remove_product:
      'ハブを無効にすると、追加された製品は削除されます。この選択を確認しますか？ 確認 キャンセル',
    copy: 'コピー',
    copy_admin: '管理者をコピー',
    copy_admin_description:
      'この管理者の出展者、モデレーター、会社、関連設定をコピーした新しい管理者を作成します。イベントはコピーされません。',
    copy_admin_fields_required: 'メールアドレスとパスワードは必須です。',
    copy_admin_submit: 'コピーを作成',
    copy_admin_success: '管理者をコピーしました。',
    copy_admin_error: '管理者のコピーに失敗しました。',
    cancel: 'キャンセル',
  },
};
